import WiresActivityPage from "components/pages/WiresActivityPage";
import { useEffect } from "react";

/**
 * @name CaptureWireActivityDefaultProfileSettingsOpen
 * @returns {React.Component}
 * @description 
 */
export default function CaptureWireActivityDefaultProfileSettingsOpen(props) {
    useEffect(() => {
        const link = document.querySelector(`[data-point=Utility_User] .custom-accordion-toggle`);
        const link2 = document.querySelector(`[data-point=Utility_Settings] > .clickable`);
        if(link && link2) {
            link.click();
            link2.click();
        }
    });
    return <WiresActivityPage />;
}